/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/Verify
 */
export interface VerifyRequestBuilder extends BaseRequestBuilder<VerifyRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<VerifyRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<VerifyRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface VerifyRequestBuilderPostQueryParameters {
    dashboardBookingId?: number;
}
/**
 * Uri template for the request builder.
 */
export const VerifyRequestBuilderUriTemplate = "{+baseurl}/Dashboard/Verify?dashboardBookingId={dashboardBookingId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const VerifyRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: VerifyRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
